import React from 'react'
import { connect } from 'react-redux'
import { servicesAPI } from 'supporticon/utils/client'
import { isJustGiving } from '../../../lib/environment'
import { clearSession, fetchSessionUser, selectUser } from '../../../store/session'

class Reconnect extends React.Component {
  componentDidMount () {
    const { clearSession, fetchSessionUser, user = {} } = this.props

    if (isJustGiving() && user.refreshToken) {
      const body = { token: user.refreshToken }
      servicesAPI.post('/v1/justgiving/oauth/reconnect', body)
        .then(response => response.data)
        .then(data => {
          const params = {
            refreshToken: data.refresh_token,
            token: data.access_token,
            authType: 'Bearer'
          }

          fetchSessionUser(params)
        })
        .catch(error => {
          clearSession()
          return Promise.reject(error)
        })
    }
  }

  render () {
    return this.props.children
  }
}

const mapStateToProps = state => ({
  user: selectUser(state)
})

const mapDispatchToProps = { clearSession, fetchSessionUser }

export default connect(mapStateToProps, mapDispatchToProps)(Reconnect)
